import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';

import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WeatherType } from './interfaces'
import { PlaceOfWeather } from './place-of-weather.component';
import { WeatherService } from './services/weather';

@Component({
  selector: 'weather-surface',
  standalone: true,
  imports: [AsyncPipe, PlaceOfWeather], //AsyncPipe, RouterOutlet,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class AppComponent {

  title = 'Bojana Cvejić';
  weathers$!: Observable<WeatherType[]>;
  themes: any[] = [];

  constructor(
    private weatherService: WeatherService,
  ) {}

  ngOnInit(): void {
    this.weathers$ = this.weatherService.getWeathers();
  }

  bumpToTop(id: number) {
  }

}
